export default {
  title: "Monitoring",
  refresh: "Refresh",
  loading: "Loading deployments...",

  // Filters
  filters: "Filters",
  clearFilters: "Clear filters",
  architecture: "Architecture",
  allArchitectures: "All architectures",
  environment: "Environment",
  allEnvironments: "All environments",
  status: "Status",
  allStatuses: "All statuses",

  // Statistics
  stats: {
    totalDeployments: "Total Deployments",
    architecturesDeployed: "Architectures Deployed",
    successfulDeployments: "Successful Deployments",
    failedDeployments: "Failed Deployments",
    inProgressDeployments: "In Progress",
    totalEstimatedCost: "Total Estimated Cost",
    avgDeploymentTime: "Avg. Deployment Time",
    byEnvironment: "Statistics by Environment",
    total: "total",
    deployed: "deployed",
    failed: "failed",
    perMonth: "/month"
  },

  // Deployment list
  deployments: "Deployments",
  noDeployments: "No deployments found",
  noDeploymentsText: "Start by generating Terraform infrastructure for an architecture.",
  unknownArchitecture: "Unknown Architecture",

  // Deployment statuses
  statuses: {
    pending: "Pending",
    generating: "Generating",
    generated: "Generated",
    planning: "Planning",
    planned: "Planned",
    applying: "Applying",
    deployed: "Deployed",
    failed: "Failed",
    destroying: "Destroying",
    destroyed: "Destroyed"
  },

  // Plan summary
  planSummary: "Plan Summary",
  toAdd: "to add",
  toChange: "to change",
  toDestroy: "to destroy",

  // Apply summary
  applySummary: "Apply Summary",
  added: "added",
  changed: "changed",
  destroyed: "destroyed",

  // Resources
  resourcesDeployed: "Resources Deployed",
  moreResources: "more",

  // Timeline
  timeline: {
    started: "Started",
    planned: "Planned",
    deployed: "Deployed",
    destroyed: "Destroyed"
  },

  // Cost
  estimatedCost: "Estimated Cost",
  month: "month",

  // Actions
  deploy: "Deploy",
  destroy: "Destroy",
  delete: "Delete",
  viewPipeline: "View Pipeline",

  // Confirmations
  confirmDeploy: "Are you sure you want to deploy the infrastructure to {{env}}? This will create real cloud resources and may incur costs.",
  confirmDestroy: "Are you sure you want to destroy the infrastructure in {{env}}? This action is irreversible and will delete all deployed resources.",
  confirmDelete: "Are you sure you want to delete this deployment record? This will not affect deployed resources.",

  // Messages
  deployStarted: "Deployment started successfully",
  deployFailed: "Failed to start deployment",
  destroyStarted: "Destroy started successfully",
  destroyFailed: "Failed to start destroy",
  deleteSuccess: "Deployment deleted successfully",
  deleteFailed: "Failed to delete deployment"
};
